import { useEffect, useState } from "react";
import { usePicker } from "../../../../../../contexts/pickerContext/pickerContext";
import useQueryParams from "../../../../../../hooks/useQueryParams";
import { filterPickerProjects } from "../../../../../../contexts/pickerContext/helpers";
import useInbox from "hooks/useInbox.ts";
import { useAppSelector } from "store/hooks";
import { selectPickerSearchParams } from "store/selectors/inboxSelectors";

/**
 * Custom hook that provides additional search information based on the current page and search term.
 * If the current page is JUMBOmail mails, it calculates how many picker projects are found for the current search term.
 * If the current page is picker projects, it calculates how many JUMBOmails are found for the current search term.
 *
 * @returns An object containing the additional search quantity.
 */
const useAdditionalSearchInfo = () => {
  const { getPickerMailList } = usePicker();
  const { getQueryParam } = useQueryParams();
  const { getMailsQuantity } = useInbox();
  const pickerSearchParams = useAppSelector(selectPickerSearchParams);

  const [additionalSearchQuantity, setAdditionalSearchQuantity] = useState(0);

  useEffect(() => {
    // If current page is JUMBOmail mails, calculate
    // how much picker projects found for the current search term
    if (getQueryParam("t") !== "picker") {
      const mailList = getPickerMailList();
      const searchValue = getQueryParam("q") || "";
      const searchValueLower = searchValue.toLowerCase();
      const additionalSearchQuantity = filterPickerProjects(
        mailList,
        searchValueLower,
        (pickerSearchParams?.ps || []) as string[]
      ).length;
      setAdditionalSearchQuantity(additionalSearchQuantity);
    } else {
        // If current page is picker projects, calculate
        // how much JUMBOmails found for the current search term
      setAdditionalSearchQuantity(getMailsQuantity());
    }
  }, [
    getMailsQuantity(),
    getPickerMailList(),
    getQueryParam("ps"),
    getQueryParam("q"),
    getQueryParam("t"),
  ]);

  return {
    additionalSearchQuantity,
  };
};

export default useAdditionalSearchInfo;
